import { FaMicrophone, FaStop } from "react-icons/fa";
import { Card, Col, Container, Modal, Row, Spinner } from "react-bootstrap";
import React, { useState, useRef, useEffect } from "react";
import { MediaRecorder } from "extendable-media-recorder";
import { MdTranscribe } from "react-icons/md";
import { useSelector } from "react-redux";

import axios from "axios";

import "../styles/style.css";

import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";
import AudioUplaod from "../Components/UploadAudioFile";
import { toast } from "react-toastify";
import { getAllLectureAnalysis } from "../api/api";
import { useNavigate } from "react-router-dom";

const ffmpeg = new FFmpeg({ log: true });

const convertToMono = async (blob) => {
  try {
    await ffmpeg.load();
    await ffmpeg.writeFile("input.wav", await fetchFile(blob));
    await ffmpeg.exec(["-i", "input.wav", "-ac", "1", "output.wav"]);
    const data = await ffmpeg.readFile("output.wav");
    const monoBlob = new Blob([data.buffer], { type: "audio/wav" });
    // //console.log(monoBlob);
    return monoBlob;
  } catch (err) {
    //console.log(err);
    return new Blob();
  }
};

const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

const Lecture = () => {
  const navigate = useNavigate();
  const [isRecording, setIsRecording] = useState(false);
  const [audioURL, setAudioURL] = useState("");
  const [audioBlob, setAudioBlob] = useState(null);
  const [transcript, setTranscript] = useState("");
  const [conversations, setConversations] = useState([]);
  const chatBoxRef = useRef(null);
  const [audios, setAudios] = useState([]);
  const [ehrInfo, setEhrInfo] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const timerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [transcript]);

  const user = useSelector((state) => state?.userInfo?.user);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const intervalIdRef = useRef(null);

  function parseLectureNotesToJSON(rawText) {
    const sections = rawText.split(/\n\s*\d+\.\s+/).slice(1); // Split into sections after numbering
    const keys = [
      "summary",
      "lectureQualityAndSubjectMastery",
      "studentInteraction",
      "questionsAsked",
    ];

    const jsonResult = {};

    sections.forEach((section, index) => {
      const splitPoint = section.indexOf(":");
      const content =
        splitPoint !== -1
          ? section.slice(splitPoint + 1).trim()
          : section.trim();
      jsonResult[keys[index]] = content;
    });

    return jsonResult;
  }

  const startRecording = async () => {
    // setEhrInfo(
    //   parseLectureNotesToJSON(
    //     '1. Summary: \nThe lecture is an introductory session for a course, presumably named CS 224, which appears to be an advanced algorithms course. The professor explains the difference between this course and CS 124, stating that while both are about algorithms, CS 224 will delve into more complex topics and models for analyzing efficiency. The professor also mentions that CS 224 will be more theory-focused, with no programming assignments, unlike CS 124. However, there is an option for an implementation project for the final assignment. The goals of the course are to increase the students\' ability to analyze and create algorithms, with the introduction of many new techniques not covered in CS 124.\n\n2. Lecture Quality and Subject Mastery: \nThe professor seems to have a clear understanding of the subject matter, as evidenced by their ability to differentiate between the two courses and explain what new concepts will be covered in CS 224. However, the lecture could be improved in terms of coherence, as the professor seems to be thinking on the spot rather than following a prepared structure. They repeatedly use phrases like "I guess" and "what else do I want to say?" which may make it harder for students to follow along.\n\n3. Student Interaction: \nThe professor starts the lecture by asking the students who among them has taken CS 124 or a similar course, indicating a level of interaction. However, the transcript does not show any further interaction, prompts for feedback, or encouragement. The professor seems to be delivering a monologue rather than engaging the students in a dialogue.\n\n4. Questions Asked: \nThere is one question asked by the professor: "who has taken CS 124 or some form of algorithms course before this?" No questions from the students are recorded in the transcript.'
    //   )
    // );
    // return;
    try {
      setTranscript("");
      setAudioURL("");
      setAudioBlob(null);
      audioChunksRef.current = [];
      setIsDisabled(true);

      const micStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        audio: true,
        video: true, // Request video to satisfy the constraint

        systemAudio: "include",
      });

      const audioContext = new AudioContext();
      //   const source = audioContext.createMediaStreamSource(combinedStream);
      //   source.connect(audioContext.destination); // Output to speakers for now

      const micSource = audioContext.createMediaStreamSource(micStream);
      const speakerSource = audioContext.createMediaStreamSource(screenStream);

      const destination = audioContext.createMediaStreamDestination();
      micSource.connect(destination);
      speakerSource.connect(destination);

      const mediaRecorder = new MediaRecorder(destination.stream, {
        mimeType: "audio/wav",
      });

      setTimeout(() => setIsDisabled(false), 2500);
      timerRef.current = setInterval(() => {
        setTimer((prevTime) => prevTime + 1);
      }, 1000);

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          // //console.log(event.data);
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        micStream.getTracks().forEach((track) => track.stop());
        screenStream.getTracks().forEach((track) => track.stop());
        if (audioChunksRef.current.length === 0) return;
        // //console.log(audioChunksRef.current.length);
        const blob = new Blob(audioChunksRef.current, { type: "audio/wav" });
        const monoBlob = await convertToMono(blob);

        //console.log(monoBlob);
        const audioURL = URL.createObjectURL(monoBlob);
        setAudioURL(audioURL);
        setAudioBlob(blob);
        setIsDisabled(true);
        await sendAudioDataPeriodically();
        //console.log(audios);
        audioChunksRef.current.map((ref) =>
          setAudios([...audios, URL.createObjectURL(ref)])
        );
        audioChunksRef.current = [];

        setLoading(true);

        // Make an API call with the audio blob
        try {
          const formData = new FormData();
          formData.append("file", monoBlob, "recording.wav");
          formData.append("user_id", user?.id);

          const response = await axios.post(
            `https://us2.sourcesoftsolutions.com:8032/lecture_analysis`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          const result = response.data;
          //   setTranscript(result?.transcript);
          //   setConversations(result?.refined_transcript?.conversation);
          setEhrInfo(result?.lecture_analysis);

          // sendAudioDataToBackend(blob, result);
        } catch (error) {
          console.error("Error uploading audio:", error);
          // toast.error(error?.message || "Error uploading audio:");
        } finally {
          setIsDisabled(false);
          setLoading(false);
        }
      };

      mediaRecorder.start(2000);
      mediaRecorderRef.current = mediaRecorder;
      setIsRecording(true);

      // Start sending audio data every 2 seconds
      intervalIdRef.current = setInterval(() => {
        if (mediaRecorder.state === "recording") {
          // sendAudioDataPeriodically();
        }
      }, 2000);
    } catch (error) {
      console.error("Error accessing microphone:", error);
      alert(
        "Failed to access microphone. Please check your browser settings and permissions."
      );
      setIsDisabled(false);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      clearInterval(intervalIdRef.current);
      clearInterval(timerRef.current);
      setTimer(0);
    }
  };

  const sendAudioDataPeriodically = async () => {
    if (audioChunksRef.current.length > 0) {
      const formData = new FormData();
      const blob = new Blob(audioChunksRef.current, { type: "audio/wav" });
      const monoBlob = await convertToMono(blob);

      formData.append("file", monoBlob, "recording.wav");

      try {
        const response = await axios.post(
          "https://us2.sourcesoftsolutions.com:8032/realtimetranscribe",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const result = response?.data;
        setTranscript(result?.transcript);
        //console.log(result);
      } catch (error) {
        console.error("Error uploading audio:", error);
      }
    } else {
      //console.log("abcdef");
    }
  };

  const handleSave = async () => {
    setSaving(true);
    const formData = new FormData();
    formData.append("audio_file", audioBlob, "recording.wav");
    // formData.append("user_id", user?.id);
    formData.append("analysis", JSON.stringify(ehrInfo));
    // formData.append("refined_transcript", JSON.stringify(result?.refined_transcript));
    formData.append("transcript", transcript);
    // formData.append("dob", dob);
    // formData.append("patient_name", patient_name);
    // if (!user) return;

    try {
      await axios.post(
        `https://us2.sourcesoftsolutions.com:8006/lecture-analysis`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer test123securetoken`,
          },
        }
      );

      toast.success("Audio data saved successfully!");
      navigate("/lecture-analyse");
    } catch (error) {
      console.error("Error saving audio data:", error);
      // toast.error(error?.message || "Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="d-flex flex-column">
      <section className="py-2">
        <Container>
          <Row className="justify-content-center">
            <Col md={12}>
              <AudioUplaod />

              <Card className="w-100">
                <Card.Body className="w-100">
                  <Card.Title className="fw-bold">Recorder</Card.Title>
                  <Card.Text className="text-muted">
                    Click the button to start recording
                  </Card.Text>

                  {transcript ? (
                    <div className="mt-3">
                      <div className="conversation-card" ref={chatBoxRef}>
                        <div
                          className={`conversation-placeholder d-flex align-items-center my-1 justify-content-center text-secondary`}
                        >
                          <span className="mx-2">
                            <MdTranscribe />
                          </span>
                          Your transcribe will be shown here
                        </div>
                      </div>
                      {transcript && (
                        <>
                          <div
                            className={`d-flex align-items-center my-4 justify-content-center`}
                          >
                            <div>
                              <span className="text-muted">{transcript}</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}

                  {audioURL && (
                    <div className="d-flex justify-content-center align-items-center mt-3">
                      <audio src={audioURL} controls className="w-100" />
                    </div>
                  )}
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    <button
                      onClick={isRecording ? stopRecording : startRecording}
                      className={`btn d-flex align-items-center ${
                        isRecording ? "btn-danger" : "btnSuccess"
                      } btn-lg`}
                      disabled={isDisabled}
                    >
                      {isRecording ? (
                        <span className="d-flex align-items-center">
                          <FaStop />
                          <span className="mx-2">Stop {formatTime(timer)}</span>
                        </span>
                      ) : (
                        <span className="d-flex align-items-center">
                          {isDisabled ? (
                            <>
                              {loading ? (
                                <span className="mx-2">Generating </span>
                              ) : (
                                <span className="mx-2">Loading transcript</span>
                              )}
                            </>
                          ) : (
                            <>
                              <FaMicrophone />
                              <span className="mx-2">Start Recording</span>
                            </>
                          )}
                        </span>
                      )}

                      {loading && (
                        <div
                          className="spinner-border text-secondary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </button>
                  </div>
                </Card.Body>
              </Card>

              {conversations?.length !== 0 && (
                <div className="mt-5">
                  <div className="card">
                    <div className="card-header">
                      <h2 className="card-title ">Conversations</h2>
                    </div>
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        {conversations.map((conv, index) => (
                          <div key={index}>
                            {conv.Doctor ? (
                              <div className="my-3">
                                <span
                                  className={`badge custom-primary me-2`}
                                  // style={{ backgroundColor: "#ff8989" }}
                                >
                                  {"Doctor"}
                                </span>
                                <span className="text">{conv?.Doctor}</span>
                              </div>
                            ) : (
                              <div className="my-3">
                                <span
                                  className={`badge custom-secondary me-2`}
                                  // style={{ backgroundColor: "#cbcbcb" }}
                                >
                                  {"Patient"}
                                </span>
                                <span className="text">{conv?.Patient}</span>
                              </div>
                            )}
                          </div>
                        ))}
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {ehrInfo && ehrInfo.length !== 0 && (
                <div className="mt-5">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Lecture Information</h3>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Lecture Quality
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Lecture Quality"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Engagement Level
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Engagement Level"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Pace of Lecture
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Pace of Lecture"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Student Interaction
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Student Interaction"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Professor Tone and Style
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Professor Tone and Style"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Key Concepts
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Key Concepts"]?.length
                              ? ehrInfo["Key Concepts"]?.map(
                                  (ehr) => ehr + ", "
                                )
                              : "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Questions Asked
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Questions Asked"] ||
                              "Information not provided"}
                          </p>
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Next Appointment</h5>
                          <p className="card-text">
                            {ehrInfo["Next_Appointment"] || "Information not provided"}
                          </p>
                        </div>
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Patient History</h5>
                          <p className="card-text">
                            {ehrInfo["Patient_History"] || "Information not provided"}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Vitals</h5>
                          <p className="card-text">
                            {ehrInfo["Vitals"] || "Information not provided"}
                          </p>
                        </div>
                        <div className="col-md-6 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">Symptoms</h5>
                          <p className="card-text">
                            {ehrInfo["Symptoms"] || "Information not provided"}
                          </p>
                        </div>
                      </div> */}
                      <div className="row">
                        <div className="col-md-12 my-3">
                          <h5 className="card-subtitle mb-1 text-muted">
                            Summary
                          </h5>
                          <p className="card-text">
                            {ehrInfo["Summary"] || "Information not provided"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-primary mt-3" onClick={handleSave}>
                    {saving ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Save Lecture Analysis"
                    )}
                  </button>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Lecture;
